import { render } from "./InstallerPage.vue?vue&type=template&id=eddc2282&scoped=true&ts=true"
import script from "./InstallerPage.vue?vue&type=script&lang=ts"
export * from "./InstallerPage.vue?vue&type=script&lang=ts"

import "./InstallerPage.vue?vue&type=style&index=0&id=eddc2282&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddc2282"]])

export default __exports__